module.exports = __webpack_public_path__ + "img/searchicon.826d38cf.svg";